import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const COMMITMENT_ASSIGNMENTS_QUERY_KEY = 'commitment-assignments';

export const getCommitmentAssignmentsQueryKey = () =>
  [COMMITMENT_ASSIGNMENTS_QUERY_KEY] as const;

const getCommitmentAssignmentsParamQueryKey = (
  commitmentId: string | undefined
) => [COMMITMENT_ASSIGNMENTS_QUERY_KEY, commitmentId] as const;

const getCommitmentAssignmentsQueryOptions = ({
  commitmentId,
  enabled,
}: {
  commitmentId?: string;
  enabled: boolean;
}) =>
  queryOptions({
    queryKey: getCommitmentAssignmentsParamQueryKey(commitmentId),
    queryFn: async () => {
      const { data } = await apiClient.commitments.getCommitmentAssignments({
        commitmentId: commitmentId ?? '',
      });
      return data.assignments ?? [];
    },
    enabled: enabled && !!commitmentId,
  });

export const useCommitmentAssignmentsQuery = ({
  commitmentId,
  enabled = true,
}: {
  commitmentId?: string;
  enabled?: boolean;
} = {}) => {
  return useQuery(
    getCommitmentAssignmentsQueryOptions({ commitmentId, enabled })
  );
};
